import React, { useState } from 'react';
import orderedCSS from './ordered.module.css';
import Loader from '../../loader';
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { axiosAuthFetch } from '../../../helpers/apiActions/authFetch';
import { useParams } from 'react-router-dom';
//import SearchableDropdown, { SearchableDropdownOrderedProducts } from '../../searchableDropdown';
import { SearchableDropdownOrderedProducts } from '../../searchableDropdown';

function AddOrderedProductForm({ products }) {
    const {id} = useParams()
    const [serialNumber, setSerialNumber] = useState('');
    //const [orders, setOrders] = useState([]);
    // const [customerID, setCustomerID] = useState('');
    const [selectedProductID, setSelectedProductID] = useState('');
    const [servicePerfomed, setServicePerformed] = useState(null);
    const [nextService, setNextService] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [firstTimeDelivery, setFirstTimeDelivery] = useState(null);
    console.log('ADD ORDERED FORM',products);

    const handleSerialNumberChange = (event) => {
        setSerialNumber(event.target.value);
    };
    // const handleServicePerformedChange = date => {
    //     const formattedDate = date.toISOString().split('T')[0];
    //     console.log(formattedDate);
    //     setServicePerformed(formattedDate);
    // }

    // const handleServicePerformedChange = (date) => {
    //     if (date) {
    //         // Set date to the first day of the selected month using UTC
    //         const firstDayOfMonth = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 1));
    //         const formattedDate = firstDayOfMonth.toISOString().split('T')[0].substring(0, 7);
    //         console.log(formattedDate);
    //         setServicePerformed(formattedDate);
    //     } else {
    //         setServicePerformed(null);
    //     }
    // };
    const handleServicePerformedChange = (date) => {
        if (date) {
            // Set date to the first day of the selected month
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
            const formattedDate = `${year}-${month}-01`;
            console.log(formattedDate);
            setServicePerformed(formattedDate);
        } else {
            setServicePerformed(null);
        }
    };
    // const handleNextServiceChange = date => {
    //     const formattedDate2 = date.toISOString().split('T')[0];
    //     setNextService(formattedDate2);
    // }
    const handleNextServiceChange = (date) => {
        if (date) {
            // Set date to the first day of the selected month
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
            const formattedDate2 = `${year}-${month}-01`;
            console.log(formattedDate2);
            setNextService(formattedDate2);
        } else {
            setNextService(null);
        }
    };
    const handleProductChange = selectedOption => {
        setSelectedProductID(selectedOption.id);
    }

    // const productOptions = products.map(product => ({
    //     value: product.id,
    //     label: product.attributes.name,
    //     data: product.attributes
    // }))
    
    // const customFilter = useCallback((candidate, input) => {
    //     // Hvis det er en søketekst
    //     if (input) {
    //         // Hent ut alle feltene fra kandidaten
    //         const { data } = candidate;
    
    //         // Søk gjennom alle relevante felt i data-objektet
    //         const searchFields = ['name', 'supplier'];
    //         for (const field of searchFields) {
    //             // Søk gjennom alle underfeltene for hvert felt
    //             const fieldValue = getFieldData(data, field);
    //             if (fieldValue && typeof fieldValue === 'string' && fieldValue.toLowerCase().includes(input.toLowerCase())) {
    //                 return true;
    //             }
    //         }
    
    //         // Hvis ingen felt matcher søketeksten, returner false
    //         return false;
    //     }
    
    //     // Hvis det ikke er noen søketekst, returner true for å matche alle alternativer
    //     return true;
    // }, []);
    
    // // Hjelpefunksjon for å hente data fra et felt med mulige underfelt
    // function getFieldData(obj, field) {
    //     const fields = field.split('.');
    //     let value = obj;
    //     for (const f of fields) {
    //         value = value[f];
    //         if (value === undefined) {
    //             return null;
    //         }
    //     }
    //     return value;
    // }

    const handleFirstTimeDeliveryChange = (date) => {
        if (date) {
            // Set date to the first day of the selected month
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
            const formattedDate = `${year}-${month}-01`;
            console.log(formattedDate);
            setFirstTimeDelivery(formattedDate);
        } else {
            setFirstTimeDelivery(null);
        }
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const customerID = id;

        try {
            const today = new Date().toISOString().split('T')[0];
            const currentDate = new Date();
            const nextYear = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1)).toISOString().split('T')[0];
            const orderedProductData = {
                "data": {
                "serial_number" : serialNumber,
                "first_time_delivery": firstTimeDelivery || today,
                "product_delivered_date" : servicePerfomed || today,
                "next_service_date": nextService || nextYear,
                }
            };

            console.log(orderedProductData);
            const productResponse = await axiosAuthFetch('https://renowned-oasis-58a898da10.strapiapp.com/api/ordered-products', orderedProductData, 'post');
            console.log(productResponse);
            const productID = productResponse.data.id;
            console.log(productID);

            const supplierData = {
                "data" : {
                    customer : {
                        connect: [customerID]
                    },
                    product : {
                        connect: [selectedProductID]
                    },
                }
            }

            const populateWithSupplierURL = await axiosAuthFetch(`https://renowned-oasis-58a898da10.strapiapp.com/api/ordered-products/${productID}`, supplierData, 'put');
           console.log(populateWithSupplierURL)
           alert('Operasjonen var vellykket!')
           setIsLoading(false);
           window.location.reload();
        } catch (error) {
            console.error('Feil ved opplasting av bilde eller innsending av skjemadata:', error);
        }
    };

    if(isLoading || !products) {
        return <Loader />
    }

    return (
        <div>
            {isLoading && <Loader />}
            <div className={orderedCSS.p}>
                <h2>Legg til levert produkt</h2>
            </div>
            <form className={orderedCSS.form} onSubmit={handleSubmit}>
                
                {/* <Select 
                    className={orderedCSS.input}
                    value={selectedProductID}
                    onChange={handleProductChange}
                    options={productOptions}
                    filterOption={customFilter}
                    placeholder="Velg produkt"
                /> */}

                <SearchableDropdownOrderedProducts 
                    objects={products}
                    onSelect={(handleProductChange)}
                />

                <input className={orderedCSS.input} type="text" value={serialNumber} onChange={handleSerialNumberChange} placeholder="Serienummer"/>
                <div className={orderedCSS.date}>
                    <p>Dato produktet ble levert:</p>
                    <ReactDatePicker 
                        selected={firstTimeDelivery}
                        onChange={handleFirstTimeDeliveryChange}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        placeholderText='Velg dato'
                    />
                </div>
                <div className={orderedCSS.date}>
                    <p>Dato for forrige service:</p>
                    <ReactDatePicker 
                        selected={servicePerfomed}
                        onChange={handleServicePerformedChange}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        placeholderText='Velg dato'
                    />
                </div>
                <div className={orderedCSS.date2}>
                    <p>Dato for neste service:</p>
                    <ReactDatePicker 
                        selected={nextService}
                        onChange={handleNextServiceChange}
                        dateFormat="MM/yyyy"
                        showMonthYearPicker
                        placeholderText='Velg dato for neste service'
                    />
                </div>
                <button className={orderedCSS.button} type="submit">Opprett produkt</button>
            </form>
        </div>
    );
}

export default AddOrderedProductForm;

